import { addBreadcrumb, trackError } from "@wevideo/core/errorTracking";
import { warn } from "@wevideo/core/logger";

export const ReduxBreadcrumbLogger = () => next => action => {
	// Recording the action is best-effort telemetry and must never block a
	// dispatch, so it gets its own try/catch.
	try {
		// record every action in the error-tracking breadcrumb timeline so it
		// appears alongside any error reported later in the session
		addBreadcrumb({ category: "redux", message: action.type, level: "info" });
	} catch {
		// ignore breadcrumb failures
	}

	try {
		return next(action);
	} catch (err) {
		// Log minimal, non-sensitive context: the full store state can contain
		// checkout/user data we don't want surfaced in the console.
		warn("Redux middleware dispatch error", { actionType: action?.type });

		trackError(err as Error);

		// Re-throw so the middleware stays transparent: a failed dispatch must
		// still surface to callers instead of being silently swallowed here.
		throw err;
	}
};
